// extracted by mini-css-extract-plugin
module.exports = {"shareButton":"share-button-module__shareButton___2MlKk","icon":"share-button-module__icon___1rSqc","iconNoBackground":"share-button-module__iconNoBackground___5izmA"};